export const ACTION_CODE = 'ATTACHMENT' + '_ACTION';
